import React, {useEffect, useState} from 'react';
import Service from '../Service/http';
import Util from '../Service/util';
import LoginSvg from "../../assets/svg/college.svg"

function College() {
  const service = new Service();
  const util = new Util();
  let [ profileData , SetProfileDta] = useState()

  useEffect(()=>{
    SetProfileDta(util.getUserDetails());
  },[])

 
  return (
    <div className='container text-center text-dark h2'  style={{minHeight:"90vh",
    backgroundImage: `url(${LoginSvg})`,
    backgroundRepeat:'no-repeat',
    fontWeight:"revert-layer",
    textShadow:"3px 3px #C0C0C0"
     }}>
  
      College Account

      <div className="p-0 m-0 h5 text-primary " style={{textDecoration: 'none',  fontWeight:"600",
   textShadow:"0px 0px #C0C0C0"
}}>
  <br/>
        <img src={ (profileData && profileData.avatar)?profileData.avatar:null} className="float-start rounded p-0 m-0" alt="profile picture"></img>
        <small>
        <div className="text-start"> &nbsp; {profileData && profileData.name?profileData.name:null} </div>
        <div className="text-start"> &nbsp; {profileData && profileData.email?profileData.email:null} </div>
        </small>
    </div>
  
    </div>
  );
}

export default College;

